import React, { useEffect } from 'react'
import { useConcursoTikTok } from '../../../../hooks/useConcursoTikTok2025';

const Tematicas = () => {

    const { tematicas, getTematicas } = useConcursoTikTok();

    useEffect(() => {
        getTematicas(2026)
    }, [])


  return (
      <div className="container-fluid section-home" id="tematicas">
          <div className="row justify-content-center">
              <div className="col-12 anchor-section">
              </div>
              <div className="col-md-8 inner-sections">
                  <div className="title-tiktok-info">
                      <h2>Temáticas</h2>
                  </div>
                  <div className="container-inner-info p-4">
                    <div dangerouslySetInnerHTML={{__html: `${tematicas?.texto}` }}></div>
                  </div>
              </div>
          </div>
      </div>
  )
}

export default Tematicas
